import { type Context } from '@databases/types/redux';

import { createSlice, type PayloadAction } from '../../shims/redux-toolkit';

export interface ContextState {
  context?: Context;
}

const initialState: ContextState = {};

const contextSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    setContext: (state, action: PayloadAction<Context>) => {
      state.context = action.payload;
    }
  }
});

export default contextSlice;
